const autocomplete = (() => {
    const inputs = {
        voivodeship: null,
        city: null,
        street: null,
    }
    /**
     * Inicjalizacja wszystkich inputów
     */
    const init = () => {
        setTimeout(() => {
            if (typeof window.autoComplete !== 'function') return;

            console.log('window.autoComplete set');
        
            const elements = document.querySelectorAll('[data-autocomplete]');
            if (!elements.length) return;

            initCustomFields();
            elements.forEach(el => initField(el));
        }, 1000);
    };

    /**
     * Inicjalizacja custom inputow 'na sztywno'
     */
    const initCustomFields = () => {
        inputs.voivodeship = document.getElementById('voivodeship');
        inputs.city = document.getElementById('city');
        inputs.street = document.getElementById('street');

        inputs.voivodeship.addEventListener('change', (e) => onChangeVoivodeship(e));
        // inputs.city.addEventListener('change', (e) => onChangeCity(e));
    }

    const onChangeVoivodeship = (e) => {
        console.log('onChangeVoivodeship')
        inputs.city.disabled = inputs.voivodeship.value === ''
        inputs.city.value = ''
        inputs.street.value = ''
        inputs.street.readOnly = false
    }

    // const onChangeCity = (e) => {
    //     console.log('onChangeCity')
    //     inputs.street.disabled = inputs.city.value === ''
    //     inputs.street.value = ''
    // }

    /**
     * Inicjalizacja pojedynczego inputa
     */
    const initField = (element) => {
        const endpoint = element.dataset.endpoint;
        const relatedEndpoint = element.dataset.relatedEndpoint;
        const relatedFilterElementId = element.dataset.relatedFilter;
        const relatedValueElementId = element.dataset.relatedValue;
        const relatedFilterElement = document.getElementById(relatedFilterElementId)
        const relatedValueElement = document.getElementById(relatedValueElementId)

        if (!endpoint) return;

        new window.autoComplete({
            selector: () => element,
            threshold: 2,
            debounce: 300,

            data: {
                src: (query) => {
                    console.log('query', query);
                    return fetch(`${endpoint}?q=${encodeURIComponent(query)}&id=${encodeURIComponent(relatedFilterElement.value)}`)
                        .then(res => res.json());
                },
                keys: ['nazwa']
            },

            resultsList: {
                maxResults: 20
            },

            resultItem: {
                highlight: true,
                element: (item, data) => {
                    const desc = `<span class="ac-desc"> ${['95', '98'].includes(data.value.typ) ? '' : 'gm. '}${data.value.gmina}</span>`;
                    item.innerHTML = `
                        <span class="ac-item">
                            <span class="ac-name">${data.match}</span>${data.value.gmina ? desc : ''}
                        </span>
                    `;
                }
            },
            
             events: {
                input: {
                    selection: (event) => {
                        console.log(event.detail.selection)
                        const item = event.detail.selection.value;
                        element.value = item.nazwa;

                        // miejscowosc
                        if(relatedValueElement) {
                            relatedValueElement.value = item.gmina_id || item.ulic_id;
                        }

                        if(relatedEndpoint) {
                            fetch(`${relatedEndpoint}?simc=${encodeURIComponent(item.simc)}`)
                                .then(res => res.json())
                                .then(data => {
                                    inputs.street.readOnly = data.length === 0
                                    inputs.street.value = data.length === 0 ? 'Brak ulicy' : ''
                                });
                        }

                        element.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            }
        });
    };

    return {
        init
    };

})();

export { autocomplete };
